import { CustomerConstant } from '../constants';
import { RequestAction } from '.';

export const getCustomers = params =>
  RequestAction.request(CustomerConstant.GET_CUSTOMERS, {
    params,
    url: '/api/customer',
  }, false);

export const setCustomers = payload => ({
  payload,
  type: CustomerConstant.SET_CUSTOMERS,
});
